var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,63.7C14.6,63.7,0.3,49.4,0.3,32S14.6,0.3,32,0.3S63.7,14.5,63.7,32S49.4,63.7,32,63.7z M32,5.1 C17.1,5.1,5.1,17.1,5.1,32s12,26.9,26.9,26.9s26.9-12,26.9-26.9S46.9,5.1,32,5.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.9,46.4c-0.2-1-1-2-2.2-2h-3.6L41.1,38L41,37.8c-0.4-0.7-1.2-1.1-1.9-1.1H30v-4.9h9.3 c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2H30v-3.3c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2V39c0,1.2,1,2.2,2.2,2.2h9.9l3.1,6.4 l0.1,0.2c0.4,0.7,1.2,1.1,1.9,1.1h5c1.2,0,2.2-1,2.2-2.2L49.9,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.2,46.7c-0.9-0.8-2.3-0.8-3.3,0.2c-3.6,4.1-9.8,4.5-14,0.9c-4.1-3.6-4.5-9.9-0.9-14l0.1-0.1 c0.1-0.1,0.2-0.1,0.2-0.2c0.9-0.9,0.9-2.3,0-3.2c-0.9-0.9-2.3-0.9-3.2,0c-2.7,2.8-4.2,6.3-4.1,10.2c0.1,3.8,1.7,7.3,4.4,9.9 c2.7,2.7,6.2,4.1,9.9,4.1c0.1,0,0.2,0,0.3,0c3.8-0.1,7.3-1.7,9.9-4.4l0.4-0.4c0.4-0.3,0.7-0.8,0.7-1.4 C39.9,47.8,39.6,47.2,39.2,46.7L39.2,46.7z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7018_00000026842233174877929940000009858484014971869339_",
    className: "st0",
    cx: 27.4,
    cy: 14.1,
    rx: 4.7,
    ry: 4.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType19);
export default __webpack_public_path__ + "static/media/aioa-icon-type-19.26db2ec24da0c9b57206dba04e63ce14.svg";
export { ForwardRef as ReactComponent };